var _circle, _g;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], t.indexOf(o) >= 0 || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.indexOf(n) >= 0) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
var SvgGr = function SvgGr(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_21734_20597",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 20,
    height: 20
  }, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 10,
    cy: 10,
    r: 10,
    fill: "#4171CF"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_21734_20597)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 10,
    cy: 10,
    r: 10,
    fill: "#F6F8FA"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 20,
    y: 4.59961,
    width: 2.3,
    height: 23,
    transform: "rotate(90 20 4.59961)",
    fill: "#295AA4"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 20,
    width: 2.3,
    height: 23,
    transform: "rotate(90 20 0)",
    fill: "#295AA4"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 20,
    y: 9.19922,
    width: 2.3,
    height: 23,
    transform: "rotate(90 20 9.19922)",
    fill: "#295AA4"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 20,
    y: 13.8008,
    width: 2.3,
    height: 23,
    transform: "rotate(90 20 13.8008)",
    fill: "#295AA4"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 20,
    y: 18.4004,
    width: 2.3,
    height: 23,
    transform: "rotate(90 20 18.4004)",
    fill: "#295AA4"
  }), /*#__PURE__*/React.createElement("rect", {
    y: 1,
    width: 10,
    height: 10.5,
    fill: "#295AA4"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 10,
    y: 4.69922,
    width: 2.3,
    height: 10,
    transform: "rotate(90 10 4.69922)",
    fill: "#F6F8FA"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 3.19922,
    y: 0.5,
    width: 2.3,
    height: 12,
    fill: "#F6F8FA"
  }))));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgGr);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/gr.14c2a6911a5d06832df32c17cee7b42a.svg";